// Selects the right overview cards for a crossplane-xr entity by the fetched XR
// kind: the App cards for App XRs, the Sandbox cards for the `Sandbox` wrapper.
// The fetch (useAppXrResource) and the composed-resources card are kind-agnostic
// and shared.
import { useAppXrResource } from './useAppXrResource';
import { AppStatusCard } from './AppStatusCard';
import { AppConfigCard } from './AppConfigCard';
import { SandboxStatusCard } from './SandboxStatusCard';
import { SandboxConfigCard } from './SandboxConfigCard';
import { SANDBOX_XR_KIND } from './sandboxXrTypes';

const useIsSandbox = () =>
  useAppXrResource().resource?.kind === SANDBOX_XR_KIND;

export const XrStatusCard = () =>
  useIsSandbox() ? <SandboxStatusCard /> : <AppStatusCard />;

export const XrConfigCard = () =>
  useIsSandbox() ? <SandboxConfigCard /> : <AppConfigCard />;
